export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/0c7f90dcab4574f291a5b93f31621815.svg";